module.exports = "<div>\n  已添加字段：\n  <table class=\"table table-bordered\">\n    <thead>\n    <tr>\n      <td>显示名</td>\n      <td>保存名</td>\n      <td>类型</td>\n    </tr>\n    </thead>\n    <tbody>\n    <tr ng-repeat=\"field in vm.fields\">\n      <td>{{field.displayName}}</td>\n      <td>{{field.name}}</td>\n      <td>{{field.type}}</td>\n    </tr>\n    </tbody>\n  </table>\n\n  <div>\n    config:\n    <pre>\n      {{vm.configToDisplay | json}}\n    </pre>\n  </div>\n  <a ui-sref=\"generator.step1\" class=\"btn bp-btn-primary\">新建一个字段</a>\n  <a ui-sref=\"generator.step3\" class=\"btn bp-btn-primary\">添加字段的关联验证</a>\n</div>\n"


/*****************
 ** WEBPACK FOOTER
 ** ./examples/generateconfig/steptpls/list.html
 ** module id = 258
 ** module chunks = 0
 **/